module.exports = "<div class=\"contacts\">\n\n    <!-- Инструменты -->\n\n    <div class=\"contacts__tools\">\n        <app-contacts-tools></app-contacts-tools>\n    </div>\n\n    <!-- Контакты -->\n\n    <ul class=\"contacts__list\">\n        <li  class=\"contacts__item\"\n            *ngFor=\"let contact of contacts | contactFilter:filterForContacts\">\n            <app-contact [contact]=\"contact\">\n            </app-contact>\n        </li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/contacts/contacts.component.html
// module id = 615
// module chunks = 1